module.exports = __webpack_public_path__ + "img/item6-7.5c1e1596.png";